(function($) {
"use strict";


/*--------------------------------------------------------------
 Define your own config for saastrend
------------------------------------------------------------*/
SaasTrend.config({
    appearAnimation : true, // Enable disable single page scroll on click
    singlePageScroll : true, // Enable disable single page scroll on click
    gmapApiKey: 'AIzaSyArZVfNvjnLNwJZlLJKuOiWHZ6vtQzzb1Y', // Set your google map api key ( required in order to map work properly )
    mailchimpUrl: 'http://xyz.us14.list-manage.com/subscribe/post?u=3e624ea3457b50d638f1bd58b&id=bc67dbaebe', // Set your mailchimp post url ( required in order to mailchimp form work properly )
});


$(function(){

/*--------------------------------------------------------------
 Define your custom js initialize
------------------------------------------------------------*/


}); /*End document ready*/


})(jQuery);







    